
const Quantitative_campus = {
  topic: 'quantitative',
  level: 'Intermediate',
  totalQuestions: 100,
  perQuestionScore: 1,
  questions: [
    {
      type: "MCQs",
      question: "If a person works 40 hours a week and earns Rs.20 per hour, what is his weekly salary?",
      choices: [
        "Rs.800",
        "Rs.1000",
        "Rs.1200",
        "Rs.1500"
      ],
      correctAnswer: "Rs.800"
    },
    {
      type: "MCQs",
      question: "A man travels 60 km at 60 km/h and returns at 40 km/h. What is the average speed for the entire journey?",
      choices: [
        "48 km/h",
        "50 km/h",
        "54 km/h",
        "56 km/h"
      ],
      correctAnswer: "48 km/h"
    },
    {
      type: "MCQs",
      question: "A box contains 10 red, 20 blue, and 30 green marbles. If a marble is picked at random, what is the probability that it is blue?",
      choices: [
        "1/3",
        "1/6",
        "1/5",
        "1/2"
      ],
      correctAnswer: "1/3"
    },
    {
      type: "MCQs",
      question: "A box contains 3 white, 5 black, and 2 yellow balls. What is the probability of drawing a white ball?",
      choices: [
        "1/10",
        "1/5",
        "1/4",
        "1/2"
      ],
      correctAnswer: "1/10"
    },
    {
      type: "MCQs",
      question: "A sum of money is invested for 2 years at a rate of 6% per annum. What will be the simple interest earned?",
      choices: [
        "Rs.12",
        "Rs.15",
        "Rs.10",
        "Rs.8"
      ],
      correctAnswer: "Rs.15"
    },
    {
      type: "MCQs",
      question: "If 60% of a number is 48, what is the number?",
      choices: [
        "60",
        "80",
        "70",
        "90"
      ],
      correctAnswer: "80"
    },
    {
      type: "MCQs",
      question: "The sum of three consecutive even numbers is 54. What is the largest of these numbers?",
      choices: [
        "18",
        "20",
        "22",
        "24"
      ],
      correctAnswer: "22"
    },
    {
      type: "MCQs",
      question: "A fruit seller has apples and oranges in the ratio 3:2. If there are 60 apples, how many oranges are there?",
      choices: [
        "30",
        "40",
        "50",
        "20"
      ],
      correctAnswer: "40"
    },
    {
      type: "MCQs",
      question: "If a number is first increased by 10% and then decreased by 10%, what is the resultant percentage change?",
      choices: [
        "1% decrease",
        "1% increase",
        "2% increase",
        "2% decrease"
      ],
      correctAnswer: "1% decrease"
    },
    {
      type: "MCQs",
      question: "What is the next number in the series: 2, 6, 12, 20, 30, ...?",
      choices: [
        "42",
        "56",
        "72",
        "90"
      ],
      correctAnswer: "42"
    },
    {
      type: "MCQs",
      question: "A machine can produce 30 units in an hour. How many units can it produce in 8 hours?",
      choices: [
        "150",
        "240",
        "300",
        "320"
      ],
      correctAnswer: "240"
    },
    {
      type: "MCQs",
      question: "A car's speed is given as 60 km/h. How far can it travel in 1.5 hours at this speed?",
      choices: [
        "80 km",
        "90 km",
        "100 km",
        "120 km"
      ],
      correctAnswer: "90 km"
    },
    {
      type: "MCQs",
      question: "If the total marks of a student in five subjects are 400, and he scores 80% in each subject. What is the score in each subject?",
      choices: [
        "60",
        "70",
        "80",
        "90"
      ],
      correctAnswer: "80"
    },
    {
      type: "MCQs",
      question: "If a man can complete a work in 15 days and another in 20 days, how long will both take to complete the work together?",
      choices: [
        "8.57 days",
        "10 days",
        "12 days",
        "14 days"
      ],
      correctAnswer: "8.57 days"
    },
    {
      type: "MCQs",
      question: "The average of four numbers is 25. If one number is excluded, the average becomes 20. What is the number that was excluded?",
      choices: [
        "20",
        "25",
        "30",
        "56"
      ],
      correctAnswer: "56"
    },
    {
      type: "MCQs",
      question: "The scores of a student in five subjects are as follows: 70, 80, 90, 75, and 85. What is the average score?",
      choices: [
        "80",
        "82",
        "85",
        "78"
      ],
      correctAnswer: "80"
    },
    {
      type: "MCQs",
      question: "A box contains 4 blue, 5 red, and 6 green balls. What is the probability of drawing a blue ball?",
      choices: [
        "2/5",
        "1/5",
        "1/3",
        "1/2"
      ],
      correctAnswer: "1/5"
    },
    {
      type: "MCQs",
      question: "The cost price of an item is Rs.200, and it is sold for Rs.240. What is the profit percentage?",
      choices: [
        "20%",
        "25%",
        "30%",
        "35%"
      ],
      correctAnswer: "20%"
    },
    {
      type: "MCQs",
      question: "If the price of a product is reduced by 10%, and later increased by 10%, what will be the net change in the price?",
      choices: [
        "0%",
        "1% increase",
        "1% decrease",
        "2% decrease"
      ],
      correctAnswer: "1% decrease"
    },
    {
      type: "MCQs",
      question: "If x + y = 10 and xy = 21, what is the value of x^2 + y^2?",
      choices: [
        "71",
        "79",
        "90",
        "100"
      ],
      correctAnswer: "71"
    },
    {
      type: "MCQs",
      question: "A man is sitting at the center of a circular table. He notices that the distance to the edge of the table is 2 feet. What is the radius of the table?",
      choices: [
        "4 feet",
        "2 feet",
        "1 foot",
        "3 feet"
      ],
      correctAnswer: "2 feet"
    },
    {
      type: "MCQs",
      question: "The total cost of 8 items is Rs.160. What is the cost of 3 items?",
      choices: [
        "Rs.60",
        "Rs.40",
        "Rs.80",
        "Rs.120"
      ],
      correctAnswer: "Rs.60"
    },
    {
      type: "MCQs",
      question: "A man is 4 times as old as his son. After 8 years, the ratio of their age will be 2:1. What are their current ages?",
      choices: [
        "4,16",
        "40, 10",
        "28, 7",
        "24, 6"
      ],
      correctAnswer: "4,16"
    },
    {
      type: "MCQs",
      question: "How many integers are there between 1 and 100 that are divisible by 3?",
      choices: [
        "33",
        "34",
        "32",
        "30"
      ],
      correctAnswer: "33"
    },
    {
      type: "MCQs",
      question: "The average age of 3 friends is 20 years. If one of them moves away, and the average age becomes 22 for the remaining two friends, how old could the friend who moved away be?",
      choices: [
        "24",
        "25",
        "26",
        "16"
      ],
      correctAnswer: "16"
    },
    {
      type: "MCQs",
      question: "If a bottle and a cap together cost Rs.1.10 and the bottle costs Rs.1.00 more than the cap, how much does the cap cost?",
      choices: [
        "Rs.0.05",
        "Rs.0.10",
        "Rs.0.15",
        "Rs.0.20"
      ],
      correctAnswer: "Rs.0.05"
    },
    {
      type: "MCQs",
      question: "If a child is 5 years old and his father is 30 years old. In how many years will the father's age be twice the child's age?",
      choices: [
        "10",
        "15",
        "5",
        "20"
      ],
      correctAnswer: "10"
    },
    {
      type: "MCQs",
      question: "If x = 5, y = 10, and z = 15, what is the value of 2x + 3y + z?",
      choices: [
        "25",
        "15",
        "5",
        "10"
      ],
      correctAnswer: "25"
    },
    {
      type: "MCQs",
      question: "The scores of a student in five subjects are as follows: 70, 80, 90, 75, and 85. What is the average score?",
      choices: [
        "80",
        "82",
        "85",
        "78"
      ],
      correctAnswer: "80"
    },
    {
      type: "MCQs",
      question: "A triangle has sides of lengths 13, 14, and 15. What is the area of the triangle?",
      choices: [
        "84",
        "91",
        "105",
        "120"
      ],
      correctAnswer: "84"
    },
    {
      type: "MCQs",
      question: "The cost price of an article is Rs.500 and it is sold at a profit of 15%, what is the selling price?",
      choices: [
        "Rs.575",
        "Rs.600",
        "Rs.650",
        "Rs.700"
      ],
      correctAnswer: "Rs.575"
    },
    {
      type: "MCQs",
      question: "A student scored 45% in an exam and failed by 10 marks. If the passing percentage is 50%, what is the maximum marks of the exam?",
      choices: [
        "200",
        "220",
        "240",
        "250"
      ],
      correctAnswer: "240"
    },
    {
      type: "MCQs",
      question: "What is the total surface area of a cylinder with a radius of 3 cm and height of 10 cm?",
      choices: [
        "78 cm²",
        "81 cm²",
        "84 cm²",
        "90 cm²"
      ],
      correctAnswer: "81 cm²"
    },
    {
      type: "MCQs",
      question: "The difference between two numbers is 8 and their sum is 36. What are the numbers?",
      choices: [
        "20, 28",
        "16, 24",
        "30, 26",
        "14, 22"
      ],
      correctAnswer: "16, 24"
    },
    {
      type: "MCQs",
      question: "How many degrees are in the angles of a triangle?",
      choices: [
        "180°",
        "90°",
        "360°",
        "270°"
      ],
      correctAnswer: "180°"
    },
    {
      type: "MCQs",
      question: "How many ways can 5 persons be seated in a row if two particular persons must always sit together?",
      choices: [
        "120",
        "144",
        "240",
        "60"
      ],
      correctAnswer: "240"
    },
    {
      type: "MCQs",
      question: "A student scores 70% in Mathematics and 80% in Physics. If the maximum marks are the same, what is his overall percentage?",
      choices: [
        "75%",
        "77%",
        "78%",
        "80%"
      ],
      correctAnswer: "75%"
    },
    {
      type: "MCQs",
      question: "If a triangle has sides of lengths 3, 4, and 5, is it a right triangle?",
      choices: [
        "Yes",
        "No",
        "Maybe",
        "Cannot be determined"
      ],
      correctAnswer: "Yes"
    },
    {
      type: "MCQs",
      question: "If the ratio of the ages of A and B is 3:5 and that of B and C is 4:7, what is the ratio of A to C?",
      choices: [
        "12:35",
        "9:20",
        "3:7",
        "12:25"
      ],
      correctAnswer: "3:7"
    },
    {
      type: "MCQs",
      question: "A triangle has sides of lengths 10, 24, and 26. Is it a right triangle?",
      choices: [
        "Yes",
        "No",
        "Maybe",
        "Cannot be determined"
      ],
      correctAnswer: "Yes"
    },
    {
      type: "MCQs",
      question: "A number is 25% less than Rs.120. What is the reduced price?",
      choices: [
        "Rs.90",
        "Rs.80",
        "Rs.100",
        "Rs.75"
      ],
      correctAnswer: "Rs.90"
    },
    {
      type: "MCQs",
      question: "The lengths of the sides of a triangle are in the ratio 3:4:5. What is the perimeter of the triangle if the shortest side is 9 cm?",
      choices: [
        "27 cm",
        "36 cm",
        "45 cm",
        "54 cm"
      ],
      correctAnswer: "54 cm"
    },
    {
      type: "MCQs",
      question: "If a + b = 10 and a * b = 2, what is the value of a?",
      choices: [
        "6",
        "5",
        "7",
        "8"
      ],
      correctAnswer: "6"
    },
    {
      type: "MCQs",
      question: "In a directed graph with 6 vertices, where each vertex has an outdegree of 3. What is the total number of directed edges in the graph?",
      choices: [
        "12",
        "18",
        "15",
        "9"
      ],
      correctAnswer: "18"
    },
    {
      type: "MCQs",
      question: "The area of a rectangle is 200 square meters. If the length is 20 meters, what is the width?",
      choices: [
        "8 m",
        "10 m",
        "5 m",
        "12 m"
      ],
      correctAnswer: "10 m"
    },
    {
      type: "MCQs",
      question: "A cyclist travels 15 km at a speed of 20 km/h and then 25 km at 25 km/h. What is the average speed for the entire journey?",
      choices: [
        "22 km/h",
        "23 km/h",
        "24 km/h",
        "25 km/h"
      ],
      correctAnswer: "22 km/h"
    },
    {
      type: "MCQs",
      question: "The simple interest on a sum of money for 3 years at 4% per annum is Rs.240. What is the principal?",
      choices: [
        "Rs.2000",
        "Rs.1600",
        "Rs.1800",
        "Rs.1500"
      ],
      correctAnswer: "Rs.2000"
    },
    {
      type: "MCQs",
      question: "What is the value of the expression (2^3) * (2^4)?",
      choices: [
        "16",
        "32",
        "64",
        "128"
      ],
      correctAnswer: "128"
    },
    {
      type: "MCQs",
      question: "The ages of A and B are in the ratio 3:4. If the sum of their ages is 35 years, what is B's age?",
      choices: [
        "20",
        "25",
        "30",
        "15"
      ],
      correctAnswer: "20"
    },
    {
      type: "MCQs",
      question: "What will be the average of the first 50 natural numbers?",
      choices: [
        "25",
        "30",
        "35",
        "20"
      ],
      correctAnswer: "25"
    },
    {
      type: "MCQs",
      question: "A company has a total of 100 employees, out of which 60% are men. How many women are there in the company?",
      choices: [
        "40",
        "50",
        "60",
        "70"
      ],
      correctAnswer: "40"
    },
    {
      type: "MCQs",
      question: "A car travels 120 km with a speed of 60 km/h and then travels another 240 km with a speed of 80 km/h. What is the average speed for the entire trip?",
      choices: [
        "72 km/h",
        "75 km/h",
        "78 km/h",
        "80 km/h"
      ],
      correctAnswer: "72 km/h"
    },
    {
      type: "MCQs",
      question: "If the ratio of the ages of A and B is 3:5 and that of B and C is 4:7, what is the ratio of A to C?",
      choices: [
        "12:35",
        "9:20",
        "3:7",
        "12:25"
      ],
      correctAnswer: "3:7"
    },
    {
      type: "MCQs",
      question: "A man travels 60 km at 60 km/h and returns at 40 km/h. What is the average speed for the entire journey?",
      choices: [
        "48 km/h",
        "50 km/h",
        "54 km/h",
        "56 km/h"
      ],
      correctAnswer: "48 km/h"
    },
    {
      type: "MCQs",
      question: "A student scored 45% in an exam and failed by 10 marks. If the passing percentage is 50%, what is the maximum marks of the exam?",
      choices: [
        "200",
        "220",
        "240",
        "250"
      ],
      correctAnswer: "240"
    },
    {
      type: "MCQs",
      question: "A person invests Rs.5000 at a rate of 4% interest per annum for 3 years. What is the total amount received at the end of 3 years?",
      choices: [
        "Rs.5200",
        "Rs.5400",
        "Rs.6000",
        "Rs.600"
      ],
      correctAnswer: "Rs.5400"
    },
    {
      type: "MCQs",
      question: "A triangle has sides of lengths 10, 24, and 26. Is it a right triangle?",
      choices: [
        "Yes",
        "No",
        "Maybe",
        "Cannot be determined"
      ],
      correctAnswer: "Yes"
    },
    {
      type: "MCQs",
      question: "A box contains 5 red balls and 7 green balls. If two balls are drawn at random, what is the probability that both are red?",
      choices: [
        "5/66",
        "1/11",
        "10/66",
        "5/22"
      ],
      correctAnswer: "5/66"
    },
    {
      type: "MCQs",
      question: "A train leaves a station and travels at a speed of 90 km/h. How long will it take to travel 270 km?",
      choices: [
        "2 hours",
        "2.5 hours",
        "3 hours",
        "3.5 hours"
      ],
      correctAnswer: "3 hours"
    },
    {
      type: "MCQs",
      question: "If 2 pens cost Rs.2.50, how many pens can be bought for Rs.10?",
      choices: [
        "5",
        "8",
        "10",
        "20"
      ],
      correctAnswer: "20"
    },
    {
      type: "MCQs",
      question: "If an item is sold for Rs.120 after a loss of 20%, what was the cost price?",
      choices: [
        "Rs.150",
        "Rs.130",
        "Rs.160",
        "Rs.100"
      ],
      correctAnswer: "Rs.150"
    },
    {
      type: "MCQs",
      question: "A certain sum triples itself in 15 years at simple interest. What will it become in 30 years?",
      choices: [
        "Rs.6",
        "Rs.9",
        "Rs.10",
        "Rs.12"
      ],
      correctAnswer: "Rs.9"
    },
    {
      type: "MCQs",
      question: "A cyclist travels 15 km at a speed of 20 km/h and then 25 km at 25 km/h. What is the average speed for the entire journey?",
      choices: [
        "22 km/h",
        "23 km/h",
        "24 km/h",
        "25 km/h"
      ],
      correctAnswer: "22 km/h"
    },
    {
      type: "MCQs",
      question: "If a total of Rs.8000 is split between A and B in the ratio 5:3, how much does A get?",
      choices: [
        "Rs.3000",
        "Rs.5000",
        "Rs.4000",
        "Rs.6000"
      ],
      correctAnswer: "Rs.5000"
    },
    {
      type: "MCQs",
      question: "If a man can complete a work in 15 days and another in 20 days, how long will both take to complete the work together?",
      choices: [
        "8.57 days",
        "10 days",
        "12 days",
        "14 days"
      ],
      correctAnswer: "8.57 days"
    },
    {
      type: "MCQs",
      question: "The price of an article is reduced by 20%. By what percentage should the reduced price be increased to get back to the original price?",
      choices: [
        "25%",
        "30%",
        "20%",
        "23.5%"
      ],
      correctAnswer: "25%"
    },
    {
      type: "MCQs",
      question: "The lengths of the sides of a triangle are in the ratio 3:4:5. What is the perimeter of the triangle if the shortest side is 9 cm?",
      choices: [
        "27 cm",
        "36 cm",
        "45 cm",
        "54 cm"
      ],
      correctAnswer: "54 cm"
    },
    {
      type: "MCQs",
      question: "In a right triangle, if one leg is 6 cm and the hypotenuse is 10 cm, what is the length of the other leg?",
      choices: [
        "4 cm",
        "6 cm",
        "8 cm",
        "10 cm"
      ],
      correctAnswer: "8 cm"
    },
    {
      type: "MCQs",
      question: "The area of a rectangle is 200 square meters. If the length is 20 meters, what is the width?",
      choices: [
        "8 m",
        "10 m",
        "5 m",
        "12 m"
      ],
      correctAnswer: "10 m"
    },
    {
      type: "MCQs",
      question: "If a + b = 10 and a * b = 2, what is the value of a?",
      choices: [
        "6",
        "5",
        "7",
        "8"
      ],
      correctAnswer: "6"
    },
    {
      type: "MCQs",
      question: "A product was sold for Rs.240 after a discount of 20%. What was its marked price?",
      choices: [
        "Rs.300",
        "Rs.350",
        "Rs.400",
        "Rs.450"
      ],
      correctAnswer: "Rs.300"
    },
    {
      type: "MCQs",
      question: "If the roots of the quadratic equation x^2 - 5x + k = 0 are equal, what is the value of k?",
      choices: [
        "4",
        "5",
        "6",
        "7"
      ],
      correctAnswer: "4"
    },
    {
      type: "MCQs",
      question: "The sum of two numbers is 25, and their product is 144. What are the two numbers?",
      choices: [
        "9 and 16",
        "12 and 13",
        "10 and 15",
        "11 and 14"
      ],
      correctAnswer: "9 and 16"
    },
    {
      type: "MCQs",
      question: "A triangle has sides of lengths 10, 24, and 26. Is it a right triangle?",
      choices: [
        "Yes",
        "No",
        "Maybe",
        "Cannot be determined"
      ],
      correctAnswer: "Yes"
    },
    {
      type: "MCQs",
      question: "The sum of three consecutive integers is 72. What is the largest of the three integers?",
      choices: [
        "24",
        "25",
        "26",
        "27"
      ],
      correctAnswer: "24"
    },
    {
      type: "MCQs",
      question: "If two sides of a triangle are 8 cm and 15 cm, what could be the length of the third side?",
      choices: [
        "22 cm",
        "6 cm",
        "15 cm",
        "7 cm"
      ],
      correctAnswer: "6 cm"
    },
    {
      type: "MCQs",
      question: "A train is 250 m long and crosses a bridge 750 m long in 30 seconds. What is the speed of the train?",
      choices: [
        "40 km/h",
        "60 km/h",
        "80 km/h",
        "100 km/h"
      ],
      correctAnswer: "60 km/h"
    },
    {
      type: "MCQs",
      question: "If the ratio of x to y is 3:5. If x = 15, what is the value of y?",
      choices: [
        "25",
        "30",
        "35",
        "40"
      ],
      correctAnswer: "25"
    },
    {
      type: "MCQs",
      question: "A man is sitting at the center of a circular table. He notices that the distance to the edge of the table is 2 feet. What is the radius of the table?",
      choices: [
        "4 feet",
        "2 feet",
        "1 foot",
        "3 feet"
      ],
      correctAnswer: "2 feet"
    },
    {
      type: "MCQs",
      question: "The difference between two numbers is 8 and their sum is 36. What are the numbers?",
      choices: [
        "20, 28",
        "16, 24",
        "30, 26",
        "14, 22"
      ],
      correctAnswer: "16, 24"
    },
    {
      type: "MCQs",
      question: "A book is sold at a discount of 10% on its marked price. If the selling price is Rs.180, what is the marked price?",
      choices: [
        "Rs.200",
        "Rs.220",
        "Rs.250",
        "Rs.300"
      ],
      correctAnswer: "Rs.200"
    },
    {
      type: "MCQs",
      question: "If the price of a product is reduced by 10%, and later increased by 10%, what will be the net change in the price?",
      choices: [
        "0%",
        "1% increase",
        "1% decrease",
        "2% decrease"
      ],
      correctAnswer: "1% decrease"
    },
    {
      type: "MCQs",
      question: "In a class of 60 students, 25% fail in Mathematics, and 30% fail in Science. What is the percentage of students who do not fail in either subject?",
      choices: [
        "50%",
        "55%",
        "60%",
        "65%"
      ],
      correctAnswer: "65%"
    },
    {
      type: "MCQs",
      question: "A man is sitting at the center of a circular table. He notices that the distance to the edge of the table is 2 feet. What is the radius of the table?",
      choices: [
        "4 feet",
        "2 feet",
        "1 foot",
        "3 feet"
      ],
      correctAnswer: "2 feet"
    },
    {
      type: "MCQs",
      question: "A, B, and C can complete a work in 12, 15, and 20 days respectively. In how many days can they together complete the work?",
      choices: [
        "5",
        "4.8",
        "6",
        "6.5"
      ],
      correctAnswer: "4.8 days"
    },
    {
      type: "MCQs",
      question: "A triangle has sides of lengths 13, 14, and 15. What is the area of the triangle?",
      choices: [
        "84",
        "91",
        "105",
        "120"
      ],
      correctAnswer: "84"
    },
    {
      type: "MCQs",
      question: "A cyclist travels 15 km at a speed of 20 km/h and then 25 km at 25 km/h. What is the average speed for the entire journey?",
      choices: [
        "22 km/h",
        "23 km/h",
        "24 km/h",
        "25 km/h"
      ],
      correctAnswer: "22 km/h"
    },
    {
      type: "MCQs",
      question: "What is the value of the expression (2^3) * (2^4)?",
      choices: [
        "16",
        "32",
        "64",
        "128"
      ],
      correctAnswer: "128"
    },
    {
      type: "MCQs",
      question: "A student scores 45% in an exam and failed by 10 marks. If the passing percentage is 50%, what is the maximum marks of the exam?",
      choices: [
        "200",
        "220",
        "240",
        "250"
      ],
      correctAnswer: "240"
    },
    {
      type: "MCQs",
      question: "The total marks of a student in five subjects are 400, and he scores 80% in each subject. What is the score in each subject?",
      choices: [
        "60",
        "70",
        "80",
        "90"
      ],
      correctAnswer: "80"
    },
    {
      type: "MCQs",
      question: "If a sum of money is divided among A, B, and C in the ratio 2:3:5, and the total amount is Rs.2000, how much does B get?",
      choices: [
        "Rs.600",
        "Rs.800",
        "Rs.900",
        "Rs.1000"
      ],
      correctAnswer: "Rs.600"
    },
    {
      type: "MCQs",
      question: "If a total of Rs.8000 is split between A and B in the ratio 5:3, how much does A get?",
      choices: [
        "Rs.3000",
        "Rs.5000",
        "Rs.4000",
        "Rs.6000"
      ],
      correctAnswer: "Rs.5000"
    },
    {
      type: "MCQs",
      question: "The average age of 3 friends is 20 years. If one of them moves away, and the average age becomes 22 for the remaining two friends, how old could the friend who moved away be?",
      choices: [
        "24",
        "25",
        "26",
        "28"
      ],
      correctAnswer: "28"
    },
    {
      type: "MCQs",
      question: "A triangular field has a base of 10 m and height of 6 m. What is its area?",
      choices: [
        "30 m²",
        "40 m²",
        "50 m²",
        "20 m²"
      ],
      correctAnswer: "30 m²"
    },
    {
      type: "MCQs",
      question: "A rectangular field is 50 m long and 30 m wide. What is the area of the field?",
      choices: [
        "1500 m²",
        "1800 m²",
        "2000 m²",
        "2500 m²"
      ],
      correctAnswer: "1500 m²"
    },
    {
      type: "MCQs",
      question: "A box contains 3 red, 5 blue, and 4 green balls. If one ball is drawn at random, what is the probability that it is either red or blue?",
      choices: [
        "1/3",
        "2/5",
        "3/5",
        "6/11"
      ],
      correctAnswer: "8/12 or 2/3"
    },
    {
      type: "MCQs",
      question: "If a worker receives a salary of Rs.1500 after a 10% increase, what was his original salary?",
      choices: [
        "Rs.1350",
        "Rs.1400",
        "Rs.1500",
        "Rs.1600"
      ],
      correctAnswer: "Rs.1350"
    },
    {
      type: "MCQs",
      question: "The area of a rectangle is 200 square meters. If the length is 20 meters, what is the width?",
      choices: [
        "8 m",
        "10 m",
        "5 m",
        "12 m"
      ],
      correctAnswer: "10 m"
    },
    {
      type: "MCQs",
      question: "If a box contains 3 red balls and 7 green balls, and you draw two balls at random, what is the probability that both are red?",
      choices: [
        "5/66",
        "1/11",
        "10/66",
        "5/22"
      ],
      correctAnswer: "5/66"
    },
    {
      type: "MCQs",
      question: "A product was sold for Rs.240 after a discount of 20%. What was its marked price?",
      choices: [
        "Rs.300",
        "Rs.350",
        "Rs.400",
        "Rs.450"
      ],
      correctAnswer: "Rs.300"
    }
  ]
}

export default Quantitative_campus;
